export const EXPORT_STATUSES = {
    PENDING: "Pending",
    PAUSED: "Paused",
    RUNNING: "Running",
    COMPLETED: "Completed",
    CANCELED: "Canceled",
    FAILED: "Failed"
};
